/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-01 13:52:54
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-02-28 10:00:31
 */
const parentRouter = [
  {
    label: '供应商分级分类管理',
    path: ''
  }
]
const routes = [
  // {
  //   path: '',
  //   name: 'maintain',
  //   meta: {
  //     icon: 'icon-a-Property1gongyingshangzonglan',
  //     title: '分级分类维护',
  //     keepAlive: true,
  //     parentTitle: parentRouter
  //   }
  // },
  {
    path: '/classification/maintain/library',
    name: 'library',
    meta: {
      icon: 'icon-a-Property1gongyingshangzonglan',
      title: '分级分类库维护',
      keepAlive: false,
      // parentTitle: parentRouter,
      parentTitle: [...parentRouter, { label: '分级分类维护', path: '' }]
    },
    component: () => import('@main/modules/classificationManage/views/Library.vue')
  },
  {
    path: '/classification/maintain/receptionAndFeedback',
    name: 'receptionAndFeedback',
    meta: {
      icon: 'icon-a-Property1gongyingshangzonglan',
      title: '需求修改接收与反馈',
      keepAlive: false,
      // parentTitle: parentRouter,
      parentTitle: [...parentRouter, { label: '分级分类维护', path: '' }]
    },
    component: () => import('@main/modules/classificationManage/views/ReceptionAndFeedback.vue')
  },
  {
    path: '/classification/maintain/receptionAndFeedback/record',
    name: 'receptionAndFeedbackRecord',
    meta: {
      icon: 'icon-renyuanguanli',
      title: '修改需求反馈记录',
      keepAlive: false,
      parentTitle: [...parentRouter, { label: '分级分类库维护', path: '' }, { label: '需求修改接收与反馈', path: '/classification/maintain/receptionAndFeedback' }]
    },
    component: () => import('@main/modules/classificationManage/views/Record.vue')
  },
  {
    path: '/classification/analysis',
    name: 'analysis',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '分级分类数据分析',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/classificationManage/views/Analysis.vue')
  }
]
export default routes
